var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 235,
    viewBox: "0 0 263 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2979 204.72L25.9042 186.984V217.322L88.2979 235.058V204.72Z",
    fill: "#241F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.772 59.6577L-30.1344 0V102.046L181.772 161.704V59.6577Z",
    fill: "#2574DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.484 99.5775L123.654 71.4727V119.547L223.484 147.652V99.5775Z",
    fill: "#D09CE7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M258.84 159.867C229.03 194.844 164.21 194.844 64.3802 159.867C-35.4496 124.89 -98.1898 126.141 -123.841 163.619",
    stroke: "#FFA100",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLeft);
export default __webpack_public_path__ + "static/media/bg-left.10025351b9cc82f8f464ede9bedb1f28.svg";
export { ForwardRef as ReactComponent };